export const SYMBOL_META = {
  XAUUSD: { name: "Gold / US Dollar", d: 2, spread: 0.18 },
  EURUSD: { name: "Euro / US Dollar", d: 5, spread: 0.00012 },
  GBPUSD: { name: "Pound / US Dollar", d: 5, spread: 0.00018 },
  USDJPY: { name: "US Dollar / Yen", d: 3, spread: 0.015 },
  BTCUSD: { name: "Bitcoin / US Dollar", d: 1, spread: 25 },
};
export const market = SYMBOL_META;
export const SYMBOL_LIST = Object.keys(SYMBOL_META);
